'use strict'

var Marionette = require('marionette')
var Backbone = require('backbone')
var App = require('app')
var _ = require('lodash')

var View = require('./view.js')
var BodyModel = require('src/common/page-model')

var List = function (options) {
  var Controller = Marionette.Object.extend({
    initialize: function (options) {
      var self = this

      self.region = options.region

      var bodyModel = new BodyModel({
        title: 'Groups',
        buttons: [
          { label: 'add node', primary: true, slug: 'node', action: 'client-nodes:add', roles: ['super', 'admin'] }
        ]
      })

      if (options.groups) {
        self.groups = options.groups
      } else {
        // find a better solution
        if (options.client) {
          self.groups = App.globalChannel.request('group:entities', {
            query: {
              client: options.client.get('_id')
            }
          })
        } else {
          self.groups = App.globalChannel.request('group:entities')
        }
      }

      self.layout = self.getLayoutView(self.groups)
      self.client = options.client

      // view events
      this.listenTo(self.layout, 'childview:group:edit', self.onEdit)
      this.listenTo(self.layout, 'childview:group:device-edit', self.onDeviceEdit)
      this.listenTo(self.layout, 'childview:group:device-control', self.onDeviceControl)
      this.listenTo(self.layout, 'childview:group:device-schedule', self.onDeviceSchedule)

      // self.layout.on('group:add', _.bind(self.onAdd, self))

     // self.layout.on('render', function () {})
      this.listenTo(self.layout, 'render', function () {
        self.listRegion(self.groups)
      })
      //
      self.region.show(self.layout)
    // App.rootLayout.showChildView('mainRegion', self.layout)
    },
    listRegion: function (collection) {
      var self = this
      console.log(collection)
      //
      var columns = {
        '_bulk': {
          'options': {
            // 'edit': {'label': 'Edit','roles': ['master']},
            // 'control': {'label': 'Control','roles': ['super']},
            // 'delete': {'label': 'Delete','roles': ['master']}
          }
        },
        'name': {'label': 'name', 'sortable': true, 'roles': [] },
        'devicesCount': {'label': 'devices', 'sortable': true, 'roles': ['super', 'admin'] },
        '_actions': {
          'options': {
            'edit': { 'action': 'edit', 'roles': ['super', 'admin'] },
            'control': { 'action': 'control', 'roles': ['super', 'admin'] },
            'schedule': {'action': 'schedule', 'roles': []}
          }
        }
      }

      //
      var layout = this.getListView(collection, columns)

      self.listenTo(layout, 'listview:childview:item:edit', self.onDeviceEdit)
      self.listenTo(layout, 'listview:childview:item:control', self.onDeviceControl)
      self.listenTo(layout, 'listview:childview:item:schedule', self.onDeviceSchedule)
      self.listenTo(layout, 'bulk:action', self.onBulk)

      // view events
      // self.layout.on('childview:device:edit', _.bind(self.onEdit, self))
      // self.layout.on('childview:device:control', _.bind(self.onControl, self))
      // self.layout.on('childview:device:show', _.bind(self.onShow, self))

      self.layout.getRegion('listRegion').show(layout)
    },
    onDeviceEdit: function (args) {
      App.globalChannel.trigger('device:edit', {region: App.rootLayout.getRegion('dialogRegion'), group: args.model})
    },
    onDeviceControl: function (args) {
      App.globalChannel.trigger('device:control', {region: App.rootLayout.getRegion('dialogRegion'), group: args.model})
    },
    onDeviceSchedule: function (args) {
      App.globalChannel.trigger('schedule:new', {region: App.rootLayout.getRegion('dialogRegion'), group: args.model })
    },
    onEdit: function (args) {
      App.globalChannel.trigger('group:edit', {region: App.rootLayout.getRegion('dialogRegion'), model: args.model})
    },
    getListView: function (collection, columns) {
      // create the listview based on the list component
      return new View.listView({
        collection: collection,
        columns: columns,
        childView: View.listItem // use a custom childview
      })
    },
    getLayoutView: function (collection) {
      console.log('collection')
      console.log()
      return new View.layout({collection: collection})
    }
  })

  return new Controller(options)
}

module.exports = List



// WEBPACK FOOTER //
// ./js/modules/groups/list/index.js